import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { useQuasar } from 'quasar'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import { useTimers } from '../store/timers'
import TimelineParent from './TimelineParent.vue'
import { useGetOdometerReading } from '../composables/getOdometerReading'
import { useMapLocationsTravel } from '../composables/mapLocationsTravel'
import { v4 } from 'uuid'
import { isPropertyOfObjectNullish } from '../utils'


export default /*#__PURE__*/_defineComponent({
  __name: 'TimelineBase',
  setup(__props) {

const $q = useQuasar()
const { getAllParentTimers } = storeToRefs(useTimers())

const timelineData = computed(() => {
  const newArray: any[] = []
  getAllParentTimers.value.forEach((parent, index, reverseTimers) => {
    //check if gap between parent timers
    if (
      !isPropertyOfObjectNullish(reverseTimers[index - 1], 'end_time') &&
      parent.start_time.getTime() - reverseTimers[index - 1].end_time!.getTime() > 300000 // 5 minutes
    ) {
      newArray.push({
        uuid: v4(), // just a unique key
        type: 'unknown',
        start_time: reverseTimers[index - 1].end_time,
        end_time: parent.start_time,
        editable: true,
        //used for defaulting locations/odometers when inserting timers
        data: {
          ...useMapLocationsTravel(index).departing.value,
          ...useMapLocationsTravel(index - 1).destination.value,
          lastParentIndex: index - 1,
          odometer_start: useGetOdometerReading({ index: index - 1 }).previous.value,
          odometer_end: useGetOdometerReading({ index: index }).next.value,
        },
      })
    }
    newArray.push({ ...parent, index: index })
  })

  return newArray.reverse()
})

const layout = computed(() => {
  return $q.screen.lt.sm ? 'dense' : $q.screen.lt.md ? 'comfortable' : 'loose'
})

return (_ctx: any,_cache: any) => {
  const _component_q_timeline = _resolveComponent("q-timeline")!

  return (_openBlock(), _createBlock(_component_q_timeline, { layout: layout.value }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timelineData.value, (parentTimer, index) => {
        return (_openBlock(), _createBlock(TimelineParent, {
          key: parentTimer.uuid,
          "parent-timer": parentTimer,
          index: index
        }, null, 8, ["parent-timer", "index"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["layout"]))
}
}

})